import React from 'react';

import { TabStrip, TabStripTab } from '@progress/kendo-react-layout'
import { Fabric } from 'office-ui-fabric-react';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';

import EditSurvey from './EditSurvey';
import SelectSurveyTemplate from './SelectSurveyTemplate';
import SelectProperties from './SelectProperties';
import ConfigureSurveyTemplate from './ConfigureSurveyTemplate';
import UploadTestPoints from './UploadTestPoints';

import SurveyService from '../services/SurveyService'
import Survey from '../models/SurveyModel';
import { getDataFromState } from '../common/Utilities';

import '../App.css';

class SurveyManager extends React.Component {

  hasChanges = false;

  constructor(props) {
    super(props);

    const isNew = typeof(props.match.params.job) === "undefined" && typeof(props.match.params.client) === "undefined";

    const localState = {
      job: (isNew) ? "" : props.match.params.job,
      client: (isNew) ?  "" : props.match.params.client,
      selectedTab: -1,
      navigateDialogHidden: true,
      maxTabCount: 4,   // Total # of tabs on this mage
      maxVisitedTab: 0  // Shows which tabs are enabled
    };

    // Shared state objects
    const sharedStated = {
      isNewSurvey: isNew,
      survey: new Survey().getSimpleObject(),
      templates: [],
      selectedTemplates: [],
      selectedTemplateKey: "",
      selectedTemplatesChosenFields: {},
      selectedOptions: []
      };



    this.state = { ...sharedStated, ...localState };

    // Class level flag - independent from state to track whether or not
    // a state change has occured. This indicates if a database write is necessary
    this.hasChanges = false;
  }

  existingSurvey = null;

  componentDidMount() {

    if (this.state.isNewSurvey) {
      this.setState({ selectedTab: 0 });
    } else {
      this.loadSurvey(this.state.job, this.state.client);
    }

  }

  loadSurvey = async (job, client) => {
    const db = new SurveyService();
    let maxTab = 0;
    this.existingSurvey = await db.get(job, client);
      const survey = this.existingSurvey.getSimpleObject();     
      if (survey.Templates.L.length > 0) { maxTab = 4 }
      
    this.setState({ 
      survey: survey,
      isNewSurvey: false,
      maxVisitedTab: maxTab,
      selectedTab: 0 });
  };

  // onCancel = () => {
  //   const s = {...this.state.survey};
  //   s.lastUpdate = new Date();
  //   this.setState({ survey: s });
  // }

  updateCommonState = (data, callback) => {
    this.setState({
      survey: {...data.survey},
      templates: [...data.templates],
      isNewSurvey: data.isNewSurvey,
      selectedTemplateKey: data.selectedTemplateKey,
      selectedTemplates: [...data.selectedTemplates],
      selectedTemplatesChosenFields: {...data.selectedTemplatesChosenFields},
      selectedOptions: [...data.selectedOptions]
    }, callback);
  };

  onSave = (data, moveTo) => {
    const thisInstance = this;
    this.updateCommonState(data, () => { thisInstance.onMove(moveTo); });
  };

  // holds the tab the user selected to navigate to. If there are changes this is used
  // as a temporary placeholder
  pendingSelectedTab = 0;

  onNavigateDialog = e => {
    const maxTab = (this.pendingSelectedTab > this.state.maxVisitedTab) ? this.pendingSelectedTab : this.state.maxVisitedTab;
    this.setState({
      selectedTab: this.pendingSelectedTab,
      surveyhasChanges: false,
      maxVisitedTab: maxTab,
      navigateDialogHidden: true });
  }
  onCancelNavigateDialog = e => {
    this.setState({ navigateDialogHidden: true });
  }
  handleTabSelect = (e) => {
    if (this.state.surveyhasChanges) {
      this.pendingSelectedTab = e.selected;
      this.setState({ navigateDialogHidden: false });
    } else {
      this.setState({ selectedTab: e.selected });
    }
  }

  onSurveyHasChanges = hasChanges => {
    this.setState({ surveyhasChanges: hasChanges });
  };

  onMove = (moveTo) => {
    if (moveTo === 1) {
      if (this.state.selectedTab < this.state.maxTabCount) {
        const maxTab = (this.state.selectedTab + 1 > this.state.maxVisitedTab) ? this.state.selectedTab + 1 : this.state.maxVisitedTab;
        this.setState({ selectedTab: this.state.selectedTab + 1, maxVisitedTab: maxTab });
      }
    } else if (moveTo < 0) {
      if (this.state.selectedTab > 0) {
        this.setState({ selectedTab: this.state.selectedTab - 1 });
      }
    }
  }

  render() {
    const data = getDataFromState(this.state);
    return (
        <Fabric>
            <div id='saveLbl' className='saveLabel saveHide'>Save Complete</div>
        <div className="container-fluid">
          <TabStrip selected={this.state.selectedTab} onSelect={this.handleTabSelect} style={{ fontSize: "14px" }}>
                    <TabStripTab title="Survey Info">
                        <EditSurvey data={data} moveTo={this.onMove} onSave={this.onSave} onSurveyChange={this.onSurveyHasChanges} />
            </TabStripTab>
            <TabStripTab title="Templates" disabled={this.state.maxVisitedTab < 1}>
                <SelectSurveyTemplate data={data} updateCommonState={this.updateCommonState} moveTo={this.onMove} onSave={this.onSave} onSurveyChange={this.onSurveyHasChanges} />
            </TabStripTab>
            <TabStripTab title="Template Columns" disabled={this.state.maxVisitedTab < 2}>
                <SelectProperties data={data} updateCommonState={this.updateCommonState} moveTo={this.onMove} onSave={this.onSave} onSurveyChange={this.onSurveyHasChanges} />
            </TabStripTab>
            <TabStripTab title="Column Properties" disabled={this.state.maxVisitedTab < 3}>
                <ConfigureSurveyTemplate data={data} moveTo={this.onMove} onSave={this.onSave} onSurveyChange={this.onSurveyHasChanges} />
            </TabStripTab>
            <TabStripTab title="Upload" disabled={this.state.maxVisitedTab < 4}>
                <UploadTestPoints data={data} moveTo={this.onMove} onSave={this.onSave} onSurveyChange={this.onSurveyHasChanges} />
            </TabStripTab>
          </TabStrip>
        </div>
        <Dialog
            hidden={this.state.navigateDialogHidden}
            onDismiss={this.onCancelNavigateDialog}
            dialogContentProps={{
                type: DialogType.normal,
                title: 'You will lose pending changes',
                subText:
                "Changes must be saved prior to navigating to another tab"
            }}
            modalProps={{
                isBlocking: true
            }}
            >
                <p className=' ms-Dialog-subText'>To save changes select "Keep Changes" and save your work.</p>
            <DialogFooter>
                <PrimaryButton onClick={this.onNavigateDialog} text="Lose Changes" />
                <DefaultButton onClick={this.onCancelNavigateDialog} text="Keep Changes" />
            </DialogFooter>
        </Dialog>
      </Fabric>
    )
  }
}

export default SurveyManager;
